import STYLE_HELPER from "../../helpers/styleHelper";
import {Link} from "react-router-dom";
import stringHelper from "../../helpers/string-helper";
import {useTranslation} from "react-i18next";
import Big from "big.js";

const GameDescription = props => {
    const {i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    const {game} = props
    return (
        <div className="game__description">
            <div className="col-6 col-slot">

                <Link
                    to={stringHelper.getLocalizedPath(currentLanguage, `/casino/games/${game?.slug}`)}
                    className={`slot mt-0`}>
                    <div className={`slot__cover slot__cover--${game?.color === 'no' ? 'no-layer' : ''}`}>
                      <span className="slot__img">
                        <img loading="lazy" src={game?.image} alt=""/>
                      </span>
                        <div className={`slot__title slot__title--${game?.color}`}>
                            <h3>{game?.name}</h3>
                            <span className="game-provider">{game?.provider}</span>
                        </div>
                    </div>
                    {/*<span className="slot__online">314 online</span>*/}
                </Link>
            </div>

            <div className="game__content">
                <h2>{game?.name}</h2>
                <p className="game__edge">
                    Edge: <b>{Big(1).minus(game?.payout || 0).div(100).abs().toFixed(4)}%</b> <br/>
                    {
                        game?.payout &&
                        <>
                            RTP: <b>{Big(game?.payout).toFixed(4)}%</b>
                        </>
                    }
                </p>

                <ul className="tags tags--game">
                    <div className="article game-description">
                        {
                            game?.seo?.description ?

                                <div
                                    dangerouslySetInnerHTML={{__html: game?.seo?.description}}/>
                                :

                                <p>
                                    {game?.description}
                                < /p>
                        }
                    </div>
                </ul>

                {/*<ul className="tags tags--game">*/}
                {/*    <li>*/}
                {/*        <a href="#">Bonus Buy</a>*/}
                {/*    </li>*/}
                {/*    <li>*/}
                {/*        <a href="#">Candy</a>*/}
                {/*    </li>*/}
                {/*    <li>*/}
                {/*        <a href="#">Christmas</a>*/}
                {/*    </li>*/}
                {/*    <li>*/}
                {/*        <a href="#">Drops &amp; Wins</a>*/}
                {/*    </li>*/}
                {/*    <li>*/}
                {/*        <a href="#">Featured Slots</a>*/}
                {/*    </li>*/}
                {/*    <li>*/}
                {/*        <a href="#">Pragmatic Play</a>*/}
                {/*    </li>*/}
                {/*    <li>*/}
                {/*        <a href="#">Pragmatic Play</a>*/}
                {/*    </li>*/}
                {/*    <li>*/}
                {/*        <a href="#">Recommended Games</a>*/}
                {/*    </li>*/}
                {/*    <li>*/}
                {/*        <a href="#">Sagas</a>*/}
                {/*    </li>*/}
                {/*    <li>*/}
                {/*        <a href="#">Slots</a>*/}
                {/*    </li>*/}
                {/*    <li>*/}
                {/*        <a href="#">Winter</a>*/}
                {/*    </li>*/}
                {/*</ul>*/}
                {/*<div className="article">*/}
                {/*    <p>*/}
                {/*        3.1 When registering on www.gambi.com You (“You”,*/}
                {/*        “Your”, Yourself” or the “Player” interchangeably)*/}
                {/*        enter into an agreement with Stake.*/}
                {/*    </p>*/}
                {/*    <p>*/}
                {/*        3.2 This Agreement should be read by You in its*/}
                {/*        entirety prior to your use of Stake's service or*/}
                {/*        products. Please note that the Agreement constitutes a*/}
                {/*        legally binding agreement between you and Stake.*/}
                {/*    </p>*/}
                {/*    <h3>h3 title</h3>*/}
                {/*    <p>*/}
                {/*        3.3 These Terms and Conditions come into force as soon*/}
                {/*        as you complete the registration process, which*/}
                {/*        includes checking the box accepting these Terms and*/}
                {/*        Conditions and successfully creating an account. By*/}
                {/*        using any part of the Website following account*/}
                {/*        creation, you agree to these Terms and Conditions*/}
                {/*        applying to the use of the Website.*/}
                {/*    </p>*/}
                {/*    <h4>h4 title</h4>*/}
                {/*    <p>*/}
                {/*        3.4 We are entitled to make amendments to these Terms*/}
                {/*        and Conditions at any time and without advanced*/}
                {/*        notice. If we make such amendments, we may take*/}
                {/*        appropriate steps to bring such changes to your*/}
                {/*        attention (such as by email or placing a notice on a*/}
                {/*        prominent position on the Website, together with the*/}
                {/*        amended terms and conditions) but it shall be your*/}
                {/*        sole responsibility to check for any amendments,*/}
                {/*        updates and/or modifications. Your continued use of*/}
                {/*        the website services after any such amendment to the*/}
                {/*        Terms and Conditions will be deemed as your acceptance*/}
                {/*        and agreement to be bound by such amendments, updates*/}
                {/*        and/or modifications.*/}
                {/*    </p>*/}
                {/*    <h5>h5 title</h5>*/}
                {/*    <p>*/}
                {/*        3.5 The terms of this Terms and Conditions shall*/}
                {/*        prevail in the event of any conflict between the terms*/}
                {/*        of this Terms and Conditions and of any of the game*/}
                {/*        rules or other documents referred to in this Terms and*/}
                {/*        Conditions.*/}
                {/*    </p>*/}
                {/*    <h6>h6 title</h6>*/}
                {/*    <p>*/}
                {/*        3.6 These Terms and Conditions may be published in*/}
                {/*        several languages for informational purposes and ease*/}
                {/*        of access by players. The English version is the only*/}
                {/*        legal basis of the relationship between you and us and*/}
                {/*        in the case of any discrepancy with respect to a*/}
                {/*        translation of any kind, the English version of these*/}
                {/*        Terms and Conditions shall prevail.*/}
                {/*    </p>*/}
                {/*</div>*/}
            </div>
        </div>

    )

}

export default GameDescription
